export default __webpack_public_path__ + "static/media/icon-money.101177f4.svg";